import type React from 'react';

import { Button } from '@change/ds-core-ui';
import { CloseIcon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core-react/i18n';

type Props = {
	className?: string;
	onClick: () => void;
};

export const DismissButton: React.FC<Props> = ({ className, onClick }) => {
	const { translate } = useI18n();

	return (
		<div className={className}>
			<Button
				data-qa="app-download-popup-close-button"
				onClick={onClick}
				aria-label={translate('corgi.app_download.bottom_banner_v2.dismiss_button.text')}
				variant="tertiary"
				size="small"
				iconOnly
				leadingIcon={<CloseIcon size="small" className="text-icon-strong-fixed" />}
			/>
		</div>
	);
};
